import React, { Fragment } from "react";
import { Container, Header, Grid, Image } from "semantic-ui-react";
import { Config } from "../../data/config";
import { retrievePromoInfo, resetPromoInfo, getBuildingData, redirect404 } from "../../store/actions/promotionInfo";
import { withRouter } from "react-router-dom";
import defaultBuilding from "../../semantic/dist/themes/fibrestream/assets/images/default-building.jpg";
import { mobileMatchMedia, tabletMatchMedia } from "../../util";
import classNames from "classnames";

import { connect } from "react-redux";
import NotFound from "../not-found/NotFound";
import SignUpFooter from "../footer/SignUpFooter";
import moment from 'moment';

class Promotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      t_days: 0,
      t_hours: 0,
      t_mins: 0,
      t_secs: 0,
      b_days: 0,
      b_hours: 0,
      b_mins: 0,
      b_secs: 0,
      isPromoExpired: false,
      isFinalCallExpired: false
    };
    this.counter_val = null;
    this.startCounter = this.startCounter.bind(this);
    this.setTimerValue = this.setTimerValue.bind(this);
    this.addDefaultSrc = this.addDefaultSrc.bind(this);

  }

  componentDidMount() {
    const { retrievePromoInfo, match, redirect, getBuildingData, buildingId } = this.props;
    if (!redirect) {
      retrievePromoInfo(match.params.code);
      if (!buildingId) {
        getBuildingData(match.params.code);
      }
    }


    document.querySelector('body').classList.add('bg--black');
    if (document.querySelector('.promo__button') !== null) { document.querySelector('.promo__button').style.display = 'none'};
  }

  getFormattedDate(date) {
    return moment(date).toDate();
  }

  componentDidUpdate(prevProps) {
    const { promoExpiry } = this.props;

    if (prevProps.promoExpiry !== promoExpiry) {
      let dateFuture = promoExpiry ? new Date(this.getFormattedDate(promoExpiry)) : new Date();
      this.startCounter(dateFuture);
    }
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('bg--black');
    clearTimeout(this.counter_val);
    this.props.resetPromoInfo();
    if (document.querySelector('.promo__button') !== null) { document.querySelector('.promo__button').style.display = 'flex'};
  }

  addDefaultSrc(e) {
    e.target.src = defaultBuilding
  }

  getTimeDifference(dateFuture) {
    let dateNow;
    dateNow = new Date();
    //grab current date
    return dateFuture.getTime() - dateNow.getTime();

  }

  startCounter(dateFuture) {
    let amount, days, hours, mins, secs;

    amount = this.getTimeDifference(dateFuture);
    //calc milliseconds between dates 
    days = 0; hours = 0; mins = 0; secs = 0;

    // time is already past
    if (amount <= 0) {
      this.setTimerValue(0, 0, 0, 0);

      this.setState({
        isPromoExpired: true
      })

      if (this.props.expiryDate && !this.state.isPromoExpired) {

        const expiryDate = new Date(this.getFormattedDate(this.props.expiryDate))
        if (this.getTimeDifference(expiryDate) < 0) {
          this.setState({ isFinalCallExpired: true, isPromoExpired: false })
        }
        else {
          this.counter_val = setTimeout(() => {
            this.startCounter(expiryDate)
          }, 1000);
        }
      }
      else {
        this.setState({ isFinalCallExpired: true, isPromoExpired: false })
      }
    }

    else {
      amount = Math.floor(amount / 1000);//convert to seconds from milliseconds
      days = Math.floor(amount / 86400);//days (60*60*24)
      amount = amount % 86400;

      hours = Math.floor(amount / 3600);//hours (60*60)
      amount = amount % 3600;

      mins = Math.floor(amount / 60);//minutes (60)
      amount = amount % 60;

      secs = Math.floor(amount);//seconds
      this.setTimerValue(days, hours, mins, secs)

      this.counter_val = setTimeout(() => {
        this.startCounter(dateFuture)
      }, 1000);
    }
  }

  setTimerValue(days, hours, mins, secs) {
    let v_days, v_hours, v_mins, v_secs;

    v_days = days < 10 ? ("0" + days) : days;
    v_hours = hours < 10 ? ("0" + hours) : hours;
    v_mins = mins < 10 ? ("0" + mins) : mins;
    v_secs = secs < 10 ? ("0" + secs) : secs;

    this.setState({
      t_days: days + 'd',
      t_hours: hours + 'h',
      t_mins: mins + 'm',
      t_secs: secs + 's',
      b_days: v_days,
      b_hours: v_hours,
      b_mins: v_mins,
      b_secs: v_secs,
    })
  }

  render() {
    const { title, description, redirect, status, bid } = this.props;
    const { t_days, t_hours, t_mins, t_secs, b_days, b_hours, b_mins, b_secs, isPromoExpired, isFinalCallExpired } = this.state;
    if (redirect) {
      return <NotFound />
    }

    else if (status) {
      return (
        <section className="ui vertical segment black space promotion inverted">
          <Header as='h3' className="text-uc text-prime f-size--14 promotion-text" textAlign='center'>Promotion</Header>
          <Header className="display-1 itc-mdbold" textAlign='center'>{title}</Header>
          <Container>
            <Grid className="mt-0" divided='vertically' stackable>
              <Grid.Row className="py-0">
                <Grid.Column computer={8} tablet={16} floated='left'>
                  <Grid columns={1} verticalAlign='middle' className="my-0">
                    <Grid.Row className='py-0'>
                      {
                        (mobileMatchMedia() || tabletMatchMedia()) && <Fragment>
                          <Grid.Column width={8}>

                            {(isPromoExpired) ? <p className="text-prime f-size--14 itc-mdbold offer-text">FINAL CALL!</p> : <p className="text-grey7 offer-text">Offer expires in</p>}
                          </Grid.Column>

                          {(isPromoExpired) ? <Grid.Column className="itc-mdbold offer-exp" width={8} textAlign='right'>
                            <Fragment>
                              <span id="t_days">{t_days}</span>
                              <span id="t_hours">{t_hours}</span>
                              <span id="t_mins">{t_mins}</span>
                              <span id="t_secs">{t_secs}</span>
                            </Fragment>
                          </Grid.Column>
                            :
                            <Grid.Column className="itc-mdbold offer-exp" width={8} textAlign='right'>
                              <Fragment>
                                <span id="t_days">{t_days}</span>
                                <span id="t_hours">{t_hours}</span>
                                <span id="t_mins">{t_mins}</span>
                                <span id="t_secs">{t_secs}</span>
                              </Fragment>
                            </Grid.Column>
                          }
                        </Fragment>
                      }
                      <Grid.Column>
                        <div className="img__imac">
                          <Image onError={this.addDefaultSrc} src={`${Config.frontApiUrl}/files/buildings/${bid}/crop`} fluid />
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>


                <Grid.Column computer={7} tablet={16} floated='right' className="signup-today py-0">
                  <Header as='h3' className="title text-uc" inverted>Sign Up Today</Header>
                  <div className="text-grey7">
                    <p className="desc">{description}</p>
                  </div>

                  <div className="counter">
                    {(isPromoExpired) && <p className="text-prime f-size--14 itc-mdbold mb-2">FINAL CALL!</p>}
                    {(bid !== null) &&
                      <Grid className={classNames({ "d-sm-none": isFinalCallExpired }, "my-0")}>
                        <Fragment>
                          <div className="counter__block">
                            <Header as='h1' inverted id="b_days">{b_days}</Header>
                            <p className="small text-grey7 text-uc">{b_days > 1 ? 'Days' : 'Day'}</p>
                          </div>
                          <div className="counter__block">
                            <Header as='h1' inverted id="b_hours">{b_hours}</Header>
                            <p className="small text-grey7 text-uc">hrs</p>
                          </div>
                          <div className="counter__block">
                            <Header as='h1' inverted id="b_mins">{b_mins}</Header>
                            <p className="small text-grey7 text-uc">min</p>
                          </div>
                          <div className="counter__block">
                            <Header as='h1' inverted id="b_secs">{b_secs}</Header>
                            <p className="small text-grey7 text-uc">secs</p>
                          </div>
                        </Fragment>
                      </Grid>
                    }
                    {isFinalCallExpired && <p className="text-prime itc-mdbold mb-3 w-full">Promotion has ended</p>}
                  </div>
                  {(!isFinalCallExpired) && <SignUpFooter />}
                </Grid.Column>

              </Grid.Row>
            </Grid>

          </Container>
        </section>
      )
    }
    else {
      return <div className="height--100vh" />;
    }

    //grab current date

  }
}
const mapStateToProps = state => {
  return {
    promoCode: state.promotion_info.promo_code,
    expiryDate: state.promotion_info.expiry_date,
    promoExpiry: state.promotion_info.promo_expiry,
    title: state.promotion_info.title,
    description: state.promotion_info.description,
    code: state.promotion_info.code,
    redirect: state.promotion_info.redirect,
    status: state.promotion_info.status,
    bid: state.promotion_info.bid,
    buildingId: state.connection.bid
  }
}
const mapDispatchToProps = dispatch => {
  return {
    retrievePromoInfo: code => dispatch(retrievePromoInfo(code)),
    resetPromoInfo: () => dispatch(resetPromoInfo()),
    getBuildingData: code => dispatch(getBuildingData(code)),
    redirect404: code => dispatch(redirect404(code)),

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Promotion));


// WEBPACK FOOTER //
// ./src/components/promotion/Promotion.js